export interface CheckoutPersonalDetailsFormValue {
  paperlessDocumentPreference?: boolean;
  email?: string;
  termsAndConditionsAccepted?: boolean;
}
